<template>
  <article class="panel panel-default" id="Collapse-Component">
    <dd class="panel-heading" role="tab" :id="`heading${iteration}`">
      <h4 class="panel-title m-0 font18">
        <a
        @click="accordianClick($event)"
          data-event="collapse"
          data-action="open"
          data-name="onclick"
          data-type="click"
          data-region="main content"
          :data-section="name"
          :data-text="heading.replace(/<[^>]+>/g, '').toLowerCase()"
          role="button"
          data-toggle="collapse"
          data-parent="#accordion"
          data-attribute='collapse-component'
          :href="`#collapse${iteration}-${id}`"
          aria-expanded="false"
          class="link-class"
          :aria-controls="`collapse${iteration}-${id}`"
          v-html="heading"
        ></a>
      </h4>
    </dd>
    <dl
      :id="`collapse${iteration}-${id}`"
      class="panel-collapse collapse in"
      role="tabpanel"
      :aria-labelledby="`heading${iteration}`"
    >
      <div class="panel-body">
        <ul class="objectives-list pl-3">
            <li
              class="objectives-item mb-2"
              v-for="(descriptions,i) in description"
              :key="i"
            ><span class="font-weight-bold ml-4">Topic {{i+1}}: </span>{{descriptions}}</li>
          </ul>
      </div>
    </dl>
  </article>
</template>

<script>
export default {
  mounted() {
    $(document).ready(function() {
      $(".toggle-accordion").on("click", function() {
        var accordionId = $(this).attr("accordion-id"),
          numPanelOpen = $(accordionId + " .collapse.in").length;

        $(this).toggleClass("active");
      });
    });
  },
  props:{
    name: String,
    heading:String,
    id: String,
    description: Array,
    iteration: Number
  },
  methods:{
    accordianClick(e){
      let status;
      let event = 'open';
    const accordionItem = document.querySelectorAll(".accordion-item");
      if (e.currentTarget.parentNode.classList.contains("active")) {
        e.currentTarget.parentNode.classList.remove("active");
        e.currentTarget.setAttribute("aria-expanded", "false");
        e.currentTarget.setAttribute("data-action", "open");
        event = "close";
        status = 'collapse_close';
      } else {
        Array.prototype.forEach.call(accordionItem, e => {
          e.classList.remove("active");
        });
        e.currentTarget.parentNode.classList.add("active");
        if (
          e.currentTarget.parentNode.getAttribute("aria-expanded") === "true" ||
          e.currentTarget.parentNode.getAttribute("data-action") === "close"
        ) {
          e.currentTarget.setAttribute("aria-expanded", "false");
          e.currentTarget.setAttribute("data-action", "open");
          status = 'collapse_close';
        } else {
          e.currentTarget.setAttribute("aria-expanded", "true");
          e.currentTarget.setAttribute("data-action", "close");
          status = 'collapse_open';
        }
      }

      utag.link({
        event: 'collapse',
        action: event,
        name: 'onclick',
        type: 'click',
        region: 'main content',
        section: this.name.toLowerCase(),
        text: this.heading.replace(/<[^>]+>/g, '').toLowerCase(),
        tealium_event: status
    })
    console.log('name'+this.name);
    }
  }
};
</script>

<style>
.panel-default{
  border: 1px solid rgba(0,0,0,.125);
  margin: 1.5rem 0;
  border-left: 5px solid black; 
}
.panel-default > .panel-heading {
  margin: 0;
  background-color: #fff;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  user-select: none;
}

.panel-default > .panel-heading a {
  display: block;
  padding: 10px 15px;
  color: black;
  text-decoration: none;
}

.panel-default > .panel-heading a:after {
  content: "";
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  float: right;
  transition: transform 0.25s linear;
  -webkit-transition: -webkit-transform 0.25s linear;
}

.panel-default > .panel-heading a[aria-expanded="true"]:after {
  content: "\f078";
  font-family: "Font Awesome 5 Free";
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  font-weight: 900;
}

.panel-default > .panel-heading a[aria-expanded="false"]:after {
  content: "\f078";
  font-family: "Font Awesome 5 Free";
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  font-weight: 900;
}

.accordion-option {
  width: 100%;
  float: left;
  clear: both;
  margin: 15px 0;
}

.accordion-option .title {
  font-size: 20px;
  font-weight: bold;
  float: left;
  padding: 0;
  margin: 0;
}

.accordion-option .toggle-accordion {
  float: right;
  font-size: 16px;
  color: #6a6c6f;
}

</style>
<style scoped>
.objectives-item{
  list-style: none !important;
}
</style>
